
  import { ref } from 'vue';
  import { Options, Vue } from 'vue-class-component';
  import { FilterMatchMode } from 'primevue/api';
  import { ReportsModule, ReportsStore, ActivationLogEntry } from '@/store/reports';
  import moment from 'moment';

  @Options({})
  export default class ActivationLog extends Vue {
    private reportsStore: ReportsModule = ReportsStore;

    items: ActivationLogEntry[] = [];
    loading = false;
    globalFilter = ['event', 'message', 'remarks', 'originAccount'];

    filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    formatDate(date: string) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm:ss') : '';
    }

    async mounted() {
      this.loading = true;
      this.items = await this.reportsStore.getActivationLog();
      this.loading = false;
    }
  }
